import React, { Component, useState } from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { publicRoutes, authProtectedRoutes, adminRoute } from "./routes/";
import AppRoute from "./routes/route";

import InjectAxiosInterceptors from "./helpers/InjectAxiosInterceptors";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./datatables.scss";
import "./theme.scss";

import "./App.css";
// import "bootstrap/dist/css/bootstrap.min.css";

import accessToken from "./helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();
    return (
      <React.Fragment>
        <Router>
          <InjectAxiosInterceptors></InjectAxiosInterceptors>
          <Switch>
            {authProtectedRoutes.map((route, idx) => {
              console.log(
                "In App, For authProtectedRoutes, Path = ",
                route.path,
                " userRole:: ",
                this.state.userRole
              );
              return (
                <AppRoute
                  path={route.path}
                  layout={VerticalLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                  // userRole={this.state.userRole}
                  allowedRoles={["Users", "Admin", "PowerUser"]}
                />
              );
            })}
            {adminRoute.map((route, idx) => {
              console.log(
                "In App, For adminRoute, Path = ",
                route.path,
                " userRole:: ",
                this.state.userRole
              );
              return (
                <AppRoute
                  path={route.path}
                  layout={VerticalLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                  // userRole={this.state.userRole}
                  allowedRoles={["Admin"]}
                />
              );
            })}
            {publicRoutes.map((route, idx) => {
              console.log(
                "In App, For publicRoutes, Path = ",
                route.path,
                " userRole:: ",
                this.state.userRole
              );
              return (
                <AppRoute
                  path={route.path}
                  layout={NonAuthLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={false}
                  // userRole={this.state.userRole}
                  // allowedRoles={["Admin", "Users", null]}
                  allowedRoles={["Admin", "Users", "", "PowerUser"]}
                />
              );
            })}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.layout,
  };
};

export default connect(mapStateToProps, null)(App);
